import { useContext } from 'react';

import { IContextMenuItem } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { openConfirmDialog } from '../../services/Confirmation';
import s from './Achievements.module.scss';
import { IDeleteAchievementRequest, TAchievement } from './interfaces';

export const useContextMenuItems = (
  deleteAchievement: (request: IDeleteAchievementRequest) => Promise<any>
): Array<IContextMenuItem<TAchievement>> => {
  const { t } = useContext(LocalizationContext);

  return [
    {
      key: 'delete',
      className: s['remove-item'],
      text: t('delete'),
      iconName: 'BucketIcon',
      onClick: (achievement) =>
        openConfirmDialog(t, 'remove', {
          title: t('log.achievement.deleted'),
          message: t('log.achievement.deleted.description', achievement.name),
        }).then(({ status }) => {
          if (status === 'DECLINED') return;
          return deleteAchievement({ id: achievement.id });
        }),
    },
  ];
};
